import { Currency } from '@/Domain/Batch/Currency'

export class FinalSettlement {
    private _importeAdxudicacion: Currency | null
    private _importeAdxudacionIva: Currency | null
    private _importeMadeiraExtraida: Currency | null
    private _importeMadeiraExtraidaIva: Currency | null
    private _balance: number | null

    constructor (
      importeAdxudicacion: Currency | null,
      importeAdxudacionIva: Currency | null,
      importeMadeiraExtraida: Currency | null,
      importeMadeiraExtraidaIva: Currency | null,
      balance: number | null
    ) {
      this._importeAdxudicacion = importeAdxudicacion
      this._importeAdxudacionIva = importeAdxudacionIva
      this._importeMadeiraExtraida = importeMadeiraExtraida
      this._importeMadeiraExtraidaIva = importeMadeiraExtraidaIva
      this._balance = balance
    }

    get importeAdxudicacion (): Currency {
      if (this._importeAdxudicacion !== null) {
        return this._importeAdxudicacion
      } else { return new Currency(0) }
    }

    get importeAdxudacionIva (): Currency {
      if (this._importeAdxudacionIva !== null) {
        return this._importeAdxudacionIva
      } else { return new Currency(0) }
    }

    get importeMadeiraExtraida (): Currency {
      if (this._importeMadeiraExtraida !== null) {
        return this._importeMadeiraExtraida
      } else { return new Currency(0) }
    }

    get importeMadeiraExtraidaIva (): Currency {
      if (this._importeMadeiraExtraidaIva !== null) {
        return this._importeMadeiraExtraidaIva
      } else { return new Currency(0) }
    }

    get balance (): number {
      return this._balance ? this._balance : 0
    }
}
